export default "__VITE_ASSET__CB87NdbM__"